import { Carrier, LineType } from '@insurgrid/common';

export type LinedCarrier = Carrier & { insuranceLine?: LineType };

// A carrier offered in both lines stays personal, like on the Dec Pages link.
export function mergeCarrierLists(
  personal: Carrier[] | undefined,
  commercial: Carrier[] | undefined,
): LinedCarrier[] {
  const personalSlugs = new Set((personal ?? []).map((c) => c.slug));
  return [
    ...(personal ?? []).map((c) => ({
      ...c,
      insuranceLine: LineType.Personal,
    })),
    ...(commercial ?? [])
      .filter((c) => !personalSlugs.has(c.slug))
      .map((c) => ({ ...c, insuranceLine: LineType.Commercial })),
  ];
}

export function lineForCarrier(
  carriers: LinedCarrier[] | undefined,
  slug: string | undefined,
): LineType {
  const carrier = carriers?.find((c) => c.slug === slug);
  return carrier?.insuranceLine === LineType.Commercial
    ? LineType.Commercial
    : LineType.Personal;
}
